import assert from 'assert';

export default function saveStep({ state }, { formKey, formValue, numberOfSteps, nextFormKey }) {
  assert(typeof numberOfSteps === 'number', '`numberOfSteps` is not a number.');
  const onboarding = state.select(['onboarding']);
  const currentStepNumber = onboarding.get('currentStepNumber');

  const nextStepNumber = currentStepNumber < numberOfSteps
    ? currentStepNumber + 1
    : currentStepNumber;

  onboarding.set(['formData', formKey], formValue);
  onboarding.set(['currentStepNumber'], nextStepNumber);

  if (formKey === 'petCount'
    && nextFormKey === 'pets'
    && formValue === 0
    && nextStepNumber < numberOfSteps
  ) {
    onboarding.set(['formData', 'pets'], []);
    onboarding.set(['currentStepNumber'], nextStepNumber + 1);
  }

  if (formKey === 'marketId') {
    const market = state.get(['markets', 'byId', formValue]);
    onboarding.set(['formData', 'area'], market.settings.map.area);

    // NOTE(@archr): Skip "choose area" step for Dallas
    // PR: https://github.com/SunroomOrg/web/pull/1714
    if (formValue === 2 && nextFormKey === 'area') {
      onboarding.set(['currentStepNumber'], nextStepNumber + 1);
    }
  }

  state.commit();

  return onboarding.get('formData');
}
